import { CacheNames } from '../service-worker/types';

export async function clearFullCaches(): Promise<void> {
	const cacheNames = Object.values(CacheNames).filter(
		(cacheName) =>
			cacheName !== CacheNames.wasm && cacheName !== CacheNames.fonts,
	);
	await Promise.all(
		cacheNames.map((cacheName) =>
			caches.open(cacheName).then(async (cacheStorage) => {
				const requests = await cacheStorage.keys();
				await Promise.all(
					requests.map(async (request) => {
						const response = await cacheStorage.match(request);
						if (response) {
							await cacheStorage.delete(request);
						}
					}),
				);
			}),
		),
	);
}
